import {
  IonCol,
  IonGrid,
  IonLoading,
  IonModal,
  IonRow,
  IonText,
} from "@ionic/react";
import { useRef, useState } from "react";
import "./Reader.css";

import { pdfjs } from "react-pdf";
import PDFViewer from "../Book/Viewer";
import { getFileUrl } from "../Book/bookUtils";
pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;

interface Props {
  pages: number[];
  title: string;
  url?: string;
  onHitLastPage?: () => void;
}

const Reader: React.FC<Props> = ({
  title,
  pages,
  url,
  onHitLastPage = () => null,
}) => {
  const [bookLoader, setBookLoader] = useState<boolean>(true);

  const techno = useRef(localStorage.getItem("techno") ?? "");

  return (
    <IonModal className="modal-width" trigger="open-modal-reader">
      <IonGrid className="primary fullWidth overflow-auto">
        <IonRow className="ion-justify-content-left">
          <IonCol onClick={() => window.location.reload()} offset="1">
            <p className="bold hover-underline response-button fit-content">
              Retour au thème
            </p>
          </IonCol>
        </IonRow>
        <IonRow class="ion-justify-content-center">
          <IonCol size-lg="10" size-sm="10">
            <IonRow>
              <IonCol className="ion-justify-content-center">
                <IonText color="black" className="ion-text-center">
                  <h5 className="uppercase">{title}</h5>
                </IonText>
              </IonCol>
            </IonRow>
          </IonCol>
        </IonRow>
        <IonRow>
          <div className="fullWidth margin">
            <IonLoading
              message={"Chargement..."}
              cssClass={"spinner"}
              isOpen={bookLoader}
            />
            <div style={{ height: 500 }}>
              <PDFViewer
                label="Haute de page"
                fileURL={getFileUrl(url, techno.current + "-techno")}
                setBookLoader={(isLoad) => setBookLoader(isLoad)}
                initialPage={pages[0]}
                endPage={pages[pages.length - 1]}
                onHitLastPage={onHitLastPage}
              />
            </div>
          </div>
        </IonRow>

        <div
          style={{
            display: "flex",
            justifyContent: "space-around",
            alignItems: "center",
            padding: "20px",
          }}
        >
          <div
            style={{
              flex: 1,
            }}
          ></div>
          <div
            style={{
              flex: 1,
              display: "flex",
              justifyContent: "center",
            }}
          >
            <p
              className="bold hover-underline response-button fit-content"
              onClick={() => window.location.reload()}
            >
              Retour au thème
            </p>
          </div>
          <div
            style={{
              flex: 1,
              display: "flex",
              justifyContent: "right",
            }}
          >
            <p
              className="bold hover-underline response-button fit-content"
              onClick={() => window.location.reload()}
            >
              Voir le quizz
            </p>
          </div>
        </div>
      </IonGrid>
    </IonModal>
  );
};

export default Reader;
